import {CrownFilled} from '@ant-design/icons';
import {Divider, Flex} from 'antd';
import React from 'react';

import InfoTooltip from '../../InfoTooltip/InfoTooltip';

const MainTableTitle: React.FC<{
  title: string;
  tooltip?: string;
  showDivider?: boolean;
  isBlock?: boolean;
}> = ({title, tooltip = '', showDivider = true, isBlock}) => {
  return (
    <div className="mainTableTitle">
      <Flex justify="space-between" align="center">
        <div className="title">
          {title}
          {isBlock ? (
            <CrownFilled
              style={{color: '#FFD700', paddingLeft: 10}}
              title="Upgrade Plan"
            />
          ) : null}
        </div>
        {tooltip && (
          <InfoTooltip
            message={tooltip}
            autoAdjustOverflow={true}
            arrow={true}
          />
        )}
      </Flex>
      {showDivider && (
        <Divider
          orientationMargin="0"
          className="divider"
          style={{marginTop: '24px'}}
        />
      )}
    </div>
  );
};

export default MainTableTitle;
